import api from '../../../lib/api';
import { CollectionWrapper, ResourceFetch } from '../../../meta/types/api';
import { CONFIG } from '../../../meta/types/config';
import { ServerDomainAccount } from '../../../meta/types/user';

const { GET } = api;

const ACCOUNT_RESOURCE_BASE_PATH = `${CONFIG.identityServiceBasePath}/oauth/users/:userId/accounts`;

export interface AccountResource {
  list: ResourceFetch<CollectionWrapper<ServerDomainAccount>, { userId: string }>;
}

const AccountResource: AccountResource = {
  list: GET(`${ACCOUNT_RESOURCE_BASE_PATH}`),
};

export default AccountResource;
